<template>
  <div
    @mouseenter.stop="mouseenterEv"
    @mouseleave.stop="mouseleaveEv"
    @mousedown.stop
    :class="['new-btn-groups', 'top_setting_btn', offsetType]"
    :style="getHandleTopSite"
  >
    <div
      class="set-groups-wrap"
      v-if="
        isActiveCol &&
        !showComponentBoxSetting &&
        (this.ids.uid !== this.uid || (this.ids.uid === this.uid && isElementInLayout)) &&
        showComponentName
      "
    >
      <div class="set-groups base-set-groups">
        <i class="icon icon-portal-grid handle-icon-box"></i>
        <span>单元格</span>
      </div>
    </div>
    <handle-btn-groups
      class="upper-handle-items"
      ref="handleBtns"
      v-if="request_prefix !== 'bigScreen' && showIcon && setOnTop"
      :ids="ids"
      :isCanDel="false"
      :handleList="handleList"
      :isAllHandleBtns="false"
    />
    <div v-if="showIcon" class="base-handles" @click.stop>
      <div class="set-groups-wrap" v-if="showComponentName">
        <div class="set-groups handle-btn-name" @click.stop="displayAllHandles">
          <i class="icon icon-portal-grid"></i>
          <span>单元格</span>
        </div>
      </div>
      <div class="set-groups-wrap">
        <cx-tooltip content="克隆样式" class="set-groups" v-if="!colsOptions.rows">
          <span class="icon icon-portal-clone" @click.stop="toClonePattern"></span>
        </cx-tooltip>
        <!-- 注意！！ 部分不常用按钮隐藏不显示，不能删除 放到了右键下调用 -->
        <cx-tooltip style="display: none" content="添加列" class="set-groups">
          <span class="icon icon-portal-round-add add-click" @click.stop="update('add')"></span>
        </cx-tooltip>
        <cx-tooltip
          style="display: none"
          class="set-groups"
          :style="{ borderRight: isLast ? 'none' : '' }"
          content="复制"
          placement="top-end"
        >
          <span class="icon icon-portal-copy-small1 copy-click" @click.stop="update('paste')"></span>
        </cx-tooltip>
        <span class="line" v-if="!colsOptions.rows"></span>
        <!--      上移 下移查找父级以及判断行列有问题，后续再考虑-->
        <!--      <cx-tooltip-->
        <!--          v-show="!isFirst && isOnlyRow && isShowAllBtns"-->
        <!--          class="set-groups"-->
        <!--          content="上移"-->
        <!--          placement="top-end"-->
        <!--      >-->

        <!--        <span class="icon icon-portal-direction-left-2 icon-direction-leftUp" @click.stop="exchange($event, 'up')"></span>-->
        <!--      </cx-tooltip>-->
        <!--      <cx-tooltip-->
        <!--          v-show="!isLast && isOnlyRow && isShowAllBtns"-->
        <!--          class="set-groups"-->
        <!--          content="下移"-->
        <!--          placement="top-end"-->
        <!--      >-->

        <!--        <span class="icon icon-portal-direction-left-2 icon-direction-leftDown" @click.stop="exchange($event, 'down')"></span>-->
        <!--      </cx-tooltip>-->
        <cx-tooltip v-show="!isFirst && isOnlyCol" class="set-groups" content="左移" placement="top-end">
          <span class="icon icon-portal-direction-left-2" @click.stop="exchange($event, 'prev')"></span>
        </cx-tooltip>
        <cx-tooltip v-show="!isLast && isOnlyCol" class="set-groups" content="右移" placement="top-end">
          <span class="icon icon-portal-direction-right-2" @click.stop="exchange($event, 'next')"></span>
        </cx-tooltip>
        <span class="line" v-if="((!isFirst && isOnlyCol) || (!isLast && isOnlyCol)) && colPath.length > 1"></span>
        <div class="set-groups handle-btn-name" v-if="!showRightToolbar" @click.stop="changeShowRightToolbar">
          <span class="icon icon-portal-setting1"></span>
        </div>
        <cx-tooltip v-show="colPath.length > 1" class="set-groups" content="删除" placement="top-end">
          <span class="icon icon-portal-delete1" @click.stop="update('del')"></span>
        </cx-tooltip>
      </div>
    </div>
    <handle-btn-groups
      class="upper-handle-items"
      ref="handleBtns"
      v-if="request_prefix !== 'bigScreen' && showIcon && !setOnTop"
      :ids="ids"
      :isCanDel="false"
      :handleList="reverseHandleList"
      :isAllHandleBtns="false"
    />
  </div>
</template>

<script>
import { findParentIds, isExist, findColPathByUid, _debounce } from "utils"
import handleBtnGroups from "components/publicComponent/handleBtnGroups"
import $ from "jquery"
import { deepCloneAndFreeze } from "utils/revork"
import { CATEGORY_MODE } from "@/consts"
export default {
  props: {
    uid: {
      type: String,
      required: true
    },
    isActiveCol: {
      type: Boolean,
      required: true
    },
    ids: Object,
    myid: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    colsOptions: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isMounted: false,
      showTopSetting: false,
      isLast: false,
      isFirst: false,
      isTopCol: false,
      isOnlyCol: false,
      isOnlyRow: false,
      colPath: [],
      handleList: [],
      reverseHandleList: [],
      isHoverStatu: false,
      offsetTop: 0,
      offsetType: "top-top", // top-top、top-bottom、bottom-top、bottom-bottom表示：从上往上排列，从上往下排列，从下往上排列，从下往下排列
      isShowAllBtns: false,
      offsetLeft:0,
      showMultipleName:false
    }
  },
  components: { handleBtnGroups },
  mounted() {
    this.isMounted = true
    window.addEventListener("wheel", this.changeBtnPosition)
  },
  beforeDestroy() {
    window.removeEventListener("wheel", this.changeBtnPosition)
  },
  computed: {
    zoom() {
      return this.$store.state.states.zoomActual
    },
    scrollLeft(){
      return this.$store.state.states.scrollLeft
    },
    getHandleTopSite(){
      if(!this.isActiveCol){
        return
      }
      if(this.offsetType === "top-top") {
        return {
          bottom: "100%",
          left: `${this.offsetLeft}`
        }
      } else if(this.offsetType === "bottom-bottom") {
        return {
          top: "100%",
          left: `${this.offsetLeft}`
        }
      } else {
        return {
          top: `${-this.offsetTop / this.zoom}px`,
          left: `${this.offsetLeft}`
        }
      }
    },
    // 选中单元格内元素时
    isElementInLayout() {
      return isExist(this.ids.elementInLayoutId)
    },
    showComponentBoxSetting() {
      const hideNames = ["searchComponentPlugin", "loginLayoutComponent", "loginEngineComponentPlugin", "appNavPlugin"]
      if (this?.options?.pluginName?.length) {
        return this?.options?.pluginName?.length
          ? this.options.pluginName.find(it => {
              return hideNames.find(_it => _it === it)
            })
          : false
      } else if (this?.options?.name === "超星头像" || this?.options?.name === "列表页搜索") {
        //超星头像屏蔽单元格
        return true
      }
    },
    rectEl() {
      return document.getElementsByClassName(
        this.$event.getIdsByStrId({
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id
        })
      )[0]
    },
    showIcon() {
      if (this.isMounted === false || !this.rectEl) return false
      const isShow =
        (this.isActiveCol || this.showTopSetting || this.ids.uid === this.uid) && !isExist(this.ids.elementInLayoutId)
      if (isShow) {
        this.rectEl.style.zIndex = 9999999
      } else if (this.ids.container_id !== this.myid.container_id || this.ids.rect_id !== this.myid.rect_id) {
        this.rectEl.style.zIndex = this.options.hasOwnProperty("zIndex") ? this.options.zIndex : "auto"
      }
      if (this.ids.uid === this.myid.uid && !isExist(this.ids.elementInLayoutId)) {
        // 当前是激活单元格
        return true
      } else {
        return false
      }
      // return isShow
    },
    topSettingStyle() {
      return {
        "--toolTopBackgroundColor": this.request_prefix.includes("bigScreen") ? "white" : "black",
        "--toolTopFontColor": this.request_prefix.includes("bigScreen") ? "black" : "white",
        "--settingShow": this.showTopSetting ? "scale(1.3)" : "scale(1)"
      }
    },
    showComponentName() {
      return this.$store.state.states.showComponentName
    },
    isAdmin() {
      return this.$store.state.states.managerType === 1 ? true : false
    },
    showRightToolbar() {
      return this.$store.state.states.showRightToolbar
    },
    // 工具栏的整体高度
    maxToolHeight() {
      const handleItem  = this.$refs.handleBtns
      this.showMultipleName = handleItem && handleItem.$el.getElementsByClassName("displayBlock").length > 0 ? true : false
      const singleToolHeight = 34
      const singleToolMargin = 2
      const height = this.showMultipleName
        ? singleToolHeight + singleToolMargin * (this.handleList.length + 1)
        : singleToolHeight + singleToolMargin * 2
      return height
    },
    setOnTop() {
      return this.offsetType === "top-top" || this.offsetType === "bottom-top"
    }
  },
  watch: {
    ids: {
      deep: true,
      immediate: true,
      handler(n, o) {
        if (isExist(n.elementInLayoutId) || n.uid !== this.myid.uid) {
          return
        }
        if (!isExist(n.elementInLayoutId)) {
          this.showSetting()
          this.getHandelBtns()
          this.changeBtnPosition()
        }
      }
    },
    scrollLeft(){
      let element =  document.getElementById(`componentBox_after${this.uid}`)?.getBoundingClientRect()
      let leftmenuWidth = document.getElementsByClassName("left-menu-wrap")[0]?.getBoundingClientRect()?.width || 0
      if(element && element.left <  leftmenuWidth && element.left + element.width > leftmenuWidth){
        this.offsetLeft = (leftmenuWidth - element.left) / this.zoom
      }else{
        this.offsetLeft = 0
      }
    }
  },
  methods: {
    changeBtnPosition(){
      let timer = setTimeout(() => {
        // 距离页面上边距 = 距离页面顶部距离 - 顶部高度50 - 刻度尺高度24
        const element = document.getElementById(`componentBox_after${this.uid}`)?.getBoundingClientRect()
        if(element) {
          const rulerHeight = this.$store.state.states.showRuler ? 0 : 24
          this.offsetTop = element.top - 50 - rulerHeight
          const remainHeight = this.offsetTop >= 0 ? element.height : element.height + this.offsetTop
          if(this.offsetTop >= this.maxToolHeight) {
            this.offsetType = "top-top"
          } else if(remainHeight - this.maxToolHeight >= 100) {
            this.offsetType = "top-bottom"
          } else {
            this.offsetType = "bottom-bottom"
          }
        }
        clearTimeout(timer)
      }, 200)
    },
    getColPath() {
      this.colPath = findColPathByUid(this.options.rows, this.uid) || []
    },
    getHandelBtns() {
      this.isShowAllBtns = false
      this.handleList = []
      this.handleList = findParentIds(
        this.myid,
        this.$store.state[this.request_prefix].page.pageLayoutType,
        this.$store.state[this.request_prefix]
      )
      this.reverseHandleList = JSON.parse(JSON.stringify(this.handleList))
      this.reverseHandleList.reverse()
    },
    findParentNode() {
      localStorage.setItem("preventMouseenterEv", true)
      setTimeout(() => {
        localStorage.removeItem("preventMouseenterEv")
      }, 3000)
      //路径的倒数第二个就是上一个col
      const tarColInPath = this.colPath[this.colPath.length - 2]
      const parentCol = tarColInPath.cols[tarColInPath.colId]
      const param = {
        ...this.myid,
        uid: parentCol.uid,
        option_name: "isActive",
        option_val: "delAllActive"
      }
      //清理被选中单元格中的所有组件的选中状态
      this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
      if (parentCol.elementOptions.length) {
        const delAllTitleActive = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id
        }
        this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", delAllTitleActive)
      }
      const activeID = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        uid: parentCol.uid
      }
      this.$store.commit("states/changeElementType", "colsComponent")
      this.$store.commit("states/changeActiveID", activeID)
      this.$changeOptionsEV(parentCol.uid, "activeCol", false, null, {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id
      })
    },
    //进入克隆模式
    toClonePattern() {
      this.showTopSetting = false
      this.$store.commit("states/changeGeneralAttr", {
        valName: "isClonePattern",
        val: true
      })
    },
    calcIsLast(deep = 0) {
      if (this.isMounted === false) {
        this.isLast = false
        this.isFirst = false
      }
      this.getColPath()
      let tarColInPath = this.colPath[this.colPath.length - 1]
      let corrCols = this.isOnlyRow ? tarColInPath.rows : tarColInPath.cols
      // 分为cols和row的情况不一样，所以判断不一样
      // 目前是通过dom结构查找父级，确定是结构一变， 这个功能就费了
      if (!corrCols && deep < 10) {
        requestAnimationFrame(() => this.calcIsLast(deep + 1))
      } else {
        const index = tarColInPath.colId
        this.isLast = index === corrCols.length - 1
        this.isFirst = index === 0
      }
    },
    calcIsOnlyCol() {
      if (this.isMounted === false) this.isOnlyCol = false
      this.getColPath()
      let tarColInPath = this.colPath[this.colPath.length - 1]
      this.isOnlyCol = tarColInPath.cols.length > 1 ? true : false
      this.isOnlyRow = tarColInPath.rows.length > 1 ? true : false
    },
    hiddenSetting() {
      this.showTopSetting = false
    },
    showSetting() {
      this.showTopSetting = !this.showTopSetting
      if (this.showTopSetting) {
        // 取消掉避免重复调用
        // this.$emit("activeCol")
        this.calcDeps()
      } else if (!this.showRightToolbar) {
        // 展开右侧栏时不能取消通栏层级
        this.setPageLayoutWrapZindex(false)
      }
    },
    calcDeps() {
      this.getColPath()
      this.calcIsOnlyCol()
      this.calcIsLast()
      this.setPageLayoutWrapZindex(true)
    },
    // 设置外层页面布局的层级 当前的为最高
    setPageLayoutWrapZindex(show) {
      let parentNode = this.getParentNode(this.$el)
      if (parentNode.length === 0) {
        return
      }
      if (show) {
        parentNode[0].setAttribute("data-level", "top-level")
      } else {
        parentNode[0].removeAttribute("data-level")
      }
    },
    getParentNode(e, res = []) {
      if (e && e.parentNode) {
        const parentNode = e.parentNode
        let elClasslist = parentNode.classList
        // if(elClasslist.length === 0){
        //   return res
        // }
        if ([].find.call(elClasslist, it => it === "myContainer")) {
          return []
        } else if ([].find.call(elClasslist, it => it === "page-layout-wrapper")) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNode(parentNode, res)
        }
      } else {
        return res
      }
    },
    exchange(e, type) {
      this.before = this.getQuickShot()
      this.$store.dispatch(this.request_prefix + `/exchangeLayoutCol`, {
        ...this.myid,
        uid: this.uid,
        shareWidth: true,
        type
      })
      this.addHistory()
    },
    update(type) {
      this.before = this.getQuickShot()
      this.$store.dispatch(this.request_prefix + `/${type}LayoutCol`, {
        ...this.myid,
        uid: this.uid,
        shareWidth: true
      })
      this.addHistory()

      if (type === "exchange") {
        requestAnimationFrame(() => {
          this.$emit("reloadBtn")
        })
      }
    },
    mouseenterEv() {
      this.$emit("mouseenter")
    },
    mouseleaveEv() {
      this.$emit("mouseleave")
    },
    // 展开父级工具栏
    displayAllHandles() {
      if (this.handleList.length === 0) {
        this.getHandelBtns()
      }
      this.$nextTick(() => {
        $(this.$el).find(".upper-handle-items .handle-btn-items").toggleClass("displayBlock")
        // 添加收起当前层级的工具栏
        this.isShowAllBtns = false
      })
    },
    showAllbtns() {
      const useActiveIndex = this.options?.categoryMode === CATEGORY_MODE.SAME ? 0 : this.options.activeIndex
      const moveStatus = getMoveStatus(this.options.rows[useActiveIndex], this.uid)
      console.log(123, moveStatus)
      this.getColPath()
      this.calcIsOnlyCol()
      this.calcIsLast()
      this.isShowAllBtns = !this.isShowAllBtns
      if (this.isShowAllBtns) {
        $(this.$el).find(".upper-handle-items .handle-btn-items").removeClass("displayBlock")
      } else {
        $(this.$el).find(".upper-handle-items .handle-btn-items").addClass("displayBlock")
      }
    },
    changeShowRightToolbar() {
      this.$store.commit("states/changeShowRightToolbarStatus", true)
    },
    // 获取当前快照
    getQuickShot() {
      const { container_id, rect_id } = this.ids
      const page = this.$store.state[this.request_prefix].page
      const rect = page.children[0].children.find(rect => rect.rect_id === rect_id)
      return deepCloneAndFreeze(rect)
    },
    // 记录状态
    addHistory() {
      const newData = this.getQuickShot()
      this.$addHistory({
        type: "update",
        stateType: "updateRect",
        payload: {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        before: this.before,
        data: newData
      })
      this.before = null
    }
  }
}
</script>

<style scoped>
/*2023.7.31 新样式*/
.new-btn-groups {
  position: absolute;
  left: 0;
  right: auto;
  /*top: auto !important;*/
  bottom: calc(100% + 2px);
}

.new-btn-groups .default-icon {
  display: none;
}

/* 显示在元素内侧顶部 */
.new-btn-groups.is_top {
  margin-top: 0;
}
.new-btn-groups .base-handles {
  position: relative;
  z-index: 999;
}
.icon-direction-leftUp {
  display: inline-block;
  transform: rotate(90deg);
}
.icon-direction-leftDown {
  display: inline-block;
  transform: rotate(-90deg);
}
.set-groups-wrap span.icon {
  color: rgba(0, 0, 0, 0.8) !important;
}
.line {
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  width: 1px;
  background-color: var(--topOperationBorderColor);
  margin: 0 2px;
}
</style>
